var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { useAuthContext } from '../auth';
import { fetchUserInfo } from './helpers';
export const useUserInfo = () => {
    const { authToken } = useAuthContext();
    const [state, setState] = useState({ userInfoFetching: false });
    const getUserInfo = (emails = []) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setState({ userInfoFetching: true, userInfoData: undefined, userInfoError: undefined });
            const responseRaw = yield fetchUserInfo(emails, authToken);
            const response = yield responseRaw.json();
            if (responseRaw.status !== 200) {
                throw new Error(`Error occurred during fetch operation. ${response.error}`);
            }
            setState({ userInfoFetching: false, userInfoData: response, userInfoError: undefined });
        }
        catch (e) {
            setState({ userInfoFetching: false, userInfoData: undefined, userInfoError: e });
        }
    });
    return Object.assign(Object.assign({}, state), { getUserInfo });
};
//# sourceMappingURL=hook.js.map